import * as React from "react";
import { useNarrowLayout } from "../core/hooks/use-narrow-layout.ts";
import {
  DockingProvider,
  makeSplit,
  makeTabs,
  useDragCtx,
} from "../shared/docking/docking.component.tsx";
import { DockingShell } from "../shared/docking/docking-shell.component.tsx";
import { useSidebarEditMode } from "../shared/docking/docking-edit-bar-host.tsx";
import { MobileDashboard } from "./dashboard-mobile.component.tsx";
import { PatientMediaProvider } from "./patient-media.provider.tsx";

/* eslint-disable @typescript-eslint/no-explicit-any -- libellés de groupes d'onglets */
const cliniqueGroup = makeTabs(
  ["clinical-comments", "diagnostic", "treatment-plan", "objectives"],
  0,
  "Clinique" as any,
);

const mediasGroup = makeTabs(
  [
    makeSplit(
      "v",
      [makeTabs(["media-viewer"]), makeTabs(["patient-files"])],
      [0.5, 0.5],
    ),
  ],
  0,
  "Médias" as any,
);
/* eslint-enable @typescript-eslint/no-explicit-any */

const dashboardLayout = makeSplit(
  "h",
  [
    // Colonne gauche : patient courant (haut) + patients du jour (bas)
    makeSplit(
      "v",
      [makeTabs(["current-patient"]), makeTabs(["agenda"])],
      [0.49, 0.51],
    ),
    // Colonne principale : Clinique · Chat · Médias (visionneur + fichiers)
    makeTabs([cliniqueGroup, "patient-chat", mediasGroup], 0),
  ],
  [0.36, 0.64],
);

function ApplyEditMode() {
  const { editMode, setEditMode, actions } = useDragCtx();
  const { sidebarEditMode } = useSidebarEditMode();
  const prevSidebarRef = React.useRef(sidebarEditMode);
  React.useEffect(() => {
    if (sidebarEditMode && !editMode) {
      setEditMode(true);
    } else if (!sidebarEditMode && prevSidebarRef.current && editMode) {
      // Modifier vient d'être désactivé depuis l'extérieur → on commit pour
      // ne pas perdre les changements en cours d'édition docking.
      actions.commitEdit();
    }
    prevSidebarRef.current = sidebarEditMode;
  }, [sidebarEditMode, editMode, setEditMode, actions]);
  return null;
}

export function DashboardPage() {
  const narrow = useNarrowLayout();
  const initial = React.useMemo(() => dashboardLayout, []);

  if (narrow) {
    return (
      <PatientMediaProvider>
        <MobileDashboard />
      </PatientMediaProvider>
    );
  }

  return (
    <PatientMediaProvider>
      <DockingProvider
        initial={initial}
        storageKey="orthonexus-dashboard-docking"
      >
        <ApplyEditMode />
        <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden p-2">
          <DockingShell />
        </div>
      </DockingProvider>
    </PatientMediaProvider>
  );
}
